import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiPlay, FiZap, FiCalendar } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const FloatingVideo = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const whatsappNumber = "529844594738";

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      setIsOpen(true);
    }, 2500);

    const script1 = document.createElement('script');
    script1.src = "https://fast.wistia.com/player.js";
    script1.async = true;
    document.body.appendChild(script1);

    const script2 = document.createElement('script');
    script2.src = "https://fast.wistia.com/embed/v7lmxag8nz.js";
    script2.async = true;
    script2.type = "module";
    document.body.appendChild(script2);

    return () => clearTimeout(timer);
  }, []);

  const closeVideo = (e) => {
    if (e) e.stopPropagation();
    setIsOpen(false);
  };

  const CloseButton = ({ className }) => (
    <button 
      onClick={closeVideo} 
      className={`absolute z-50 bg-black/80 text-white p-2 text-xl rounded-full hover:bg-red-600 transition-all border border-white/20 shadow-2xl scale-75 md:scale-100 ${className}`}
    >
      <FiX />
    </button>
  );

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end gap-3 pointer-events-none">
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.5, y: 100 }} 
            animate={{ opacity: 1, scale: 1, y: 0 }} 
            exit={{ opacity: 0, scale: 0.5, y: 100 }} 
            className="w-[280px] md:w-[340px] bg-zinc-950 border-2 border-red-500 rounded-[2.5rem] shadow-[0_0_50px_rgba(239,68,68,0.4)] overflow-hidden relative pointer-events-auto"
          >
            {/* QUAD CLOSE BUTTONS - 4 SIDES */}
            <CloseButton className="top-4 left-4" />
            <CloseButton className="top-4 right-4" />
            <CloseButton className="bottom-32 left-4 md:bottom-36" />
            <CloseButton className="bottom-32 right-4 md:bottom-36" />

            <div className="absolute top-16 left-0 right-0 z-30 flex flex-col items-center gap-2 pointer-events-none">
              <motion.div initial={{ y: -20 }} animate={{ y: 0 }} className="bg-red-600 text-white px-4 py-1 rounded-full font-black text-[10px] uppercase tracking-tighter shadow-xl border border-white/20 flex items-center gap-2">
                <SafeIcon icon={FiZap} className="animate-pulse" /> NEW EVENT 2026
              </motion.div>
              {/* ✅ Points to the new repurposed landing page */}
              <Link to="/p/workshop-ingles-negocios-2026" onClick={() => setIsOpen(false)} className="bg-yellow-500 text-black px-4 py-1 rounded-lg font-black text-[10px] uppercase shadow-lg pointer-events-auto hover:bg-white transition-colors border border-black/10">
                INSCRIBIRSE AL WORKSHOP →
              </Link>
            </div>

            <div className="relative aspect-[9/16] bg-black">
              <style>{`wistia-player[media-id='v7lmxag8nz']:not(:defined) {background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/v7lmxag8nz/swatch');display: block;filter: blur(5px);padding-top:177.78%;}`}</style>
              <wistia-player media-id="v7lmxag8nz" aspect="0.5625" autoPlay="true" muted="false"></wistia-player>
            </div>

            <div className="p-5 bg-zinc-900 border-t border-zinc-800">
              <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-2xl p-3 mb-4 flex items-center gap-3">
                <div className="bg-yellow-500 p-2 rounded-lg text-black"><SafeIcon icon={FiCalendar} className="text-sm" /></div>
                <p className="text-white text-[10px] font-bold leading-tight uppercase">
                  <span className="text-yellow-500 block mb-0.5">Workshop de Negocios 2026</span> DOMINA LA COMUNICACIÓN ORAL EJECUTIVA.
                </p>
              </div>
              <div className="grid gap-2">
                <Link to="/p/workshop-ingles-negocios-2026" onClick={() => setIsOpen(false)} className="flex items-center justify-center gap-2 bg-blue-600 text-white py-4 rounded-xl font-black uppercase text-[10px] hover:bg-blue-500 transition-all shadow-xl">Ver Detalles del Programa</Link>
                <a href={`https://wa.me/${whatsappNumber}?text=Hola! Quiero información del Workshop.`} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-green-600 text-white py-3 rounded-xl font-black uppercase text-[10px] hover:bg-green-500 transition-all shadow-xl"><SafeIcon icon={FaWhatsapp} /> Shop on WhatsApp</a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      {!isOpen && isVisible && (
        <motion.button whileHover={{ scale: 1.1 }} onClick={() => setIsOpen(true)} className="w-24 h-24 rounded-full border-4 border-red-500 overflow-hidden shadow-[0_0_30px_rgba(239,68,68,0.5)] relative pointer-events-auto">
          <img src="https://fast.wistia.com/embed/medias/v7lmxag8nz/swatch" className="w-full h-full object-cover grayscale" alt="Workshop 2026" />
          <div className="absolute inset-0 bg-black/40 flex items-center justify-center text-white"><SafeIcon icon={FiPlay} className="text-3xl" /></div>
        </motion.button>
      )}
    </div>
  );
};

export default FloatingVideo;